import { atom } from "jotai";

export const app_atom = atom({
    left_nav_is_open: true,
    settings_nav_is_open: false,
    nekot_is_open: false,
    modal_is_open: false,
    modal_id: "",
});
